import { ApiClient } from "./api-client";
import { AppException } from "../exceptions/exceptions";
import { CommonErrorCodes } from "../errors/common-error-codes";
import { IBenchmarks, IInsights, IVerifiedScore } from "../types/insights";

export const getStats = async (): Promise<IInsights> => {
  const client = ApiClient.getInstance();
  try {
    const response = await client.get("/data/actionstats?groupBy=standard");
    return response.data as IInsights;
  } catch (e) {
    console.error("An error happened", e);
    throw new AppException(
      "There was an error fetching the insights. Please try again later.",
      CommonErrorCodes.API_ERROR,
    );
  }
};

export const getBenchmarks = async (): Promise<IBenchmarks> => {
  const client = ApiClient.getInstance();
  try {
    const response = await client.get("/data/benchmarkstats");
    return response.data as IBenchmarks;
  } catch (e) {
    console.error("An error happened", e);
    throw new AppException(
      "There was an error fetching the insights. Please try again later.",
      CommonErrorCodes.API_ERROR,
    );
  }
};

export const postVerifiedScore = async (): Promise<void> => {
  const client = ApiClient.getInstance();
  try {
    await client.post("/data/verifiedscore");
  } catch (e) {
    console.error("An error happened", e);
    throw new AppException(
      "There was an error submitting the verified score. Please try again later.",
      CommonErrorCodes.API_ERROR,
    );
  }
};

export const getVerificationDetails = async (): Promise<IVerifiedScore> => {
  const client = ApiClient.getInstance();
  try {
    const response = await client.get("/data/verifiedscore");
    const data = response.data as IVerifiedScore;

    return {
      ...data,
      verifiedScore: data.verifiedScore.map((s) => ({
        ...s,
        createdAt: new Date(s.createdAt),
      })),
      lastActionUpdatedDate: data.lastActionUpdatedDate
        ? new Date(data.lastActionUpdatedDate)
        : null,
    };
  } catch (e) {
    console.error("An error happened", e);
    throw new AppException(
      "There was an error fetching the insights. Please try again later.",
      CommonErrorCodes.API_ERROR,
    );
  }
};
